import {
    AnalyticsIcon,
    PeopleIcon
} from "@/components/icons";
import { SideBarRouteOption } from "@/types";

const invigilatorRoutes: SideBarRouteOption[] = [
    {
        name: "Dashboard",
        path: "/invigilator-account",
        icon: AnalyticsIcon,
    },
    {
        name: "Update User Details",
        path: "/invigilator-account/update-user-details",
        icon: PeopleIcon,
    }
];

export default invigilatorRoutes;
